import { useGlobalSearchStore } from '../../stores';
import type { groupMembershipRoles } from '../../../shared/enums/groupMembershipRoles';

export const useSearchResultGroupMembership = () => {
  const globalSearchStore = useGlobalSearchStore();

  const updateGroupMembershipRole = (groupId: string, newRole: groupMembershipRoles) => {
    globalSearchStore.updateResultMembershipRole(groupId, newRole);
  };

  return {
    updateGroupMembershipRole,
  };
};

